import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { authAPI } from '../utils/api';
import '../styles/Login.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      await authAPI.forgotPassword(email);
      setSent(true);
      toast.success(t('auth.resetEmailSent'));
    } catch (error) {
      toast.error(error.response?.data?.message || t('auth.resetRequestError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1>{t('auth.forgotPassword')}</h1>
          <p className="auth-explanation">{t('auth.emailIsUsername')}</p>
          {sent ? (
            <div className="auth-result">
              <p>{t('auth.resetEmailInstructions')}</p>
              <Link to="/login">{t('auth.backToLogin')}</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="recovery-email">{t('auth.email')}</label>
                <input id="recovery-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required autoComplete="email" />
              </div>
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? t('common.loading') : t('auth.sendResetLink')}
              </button>
              <div className="auth-toggle"><Link to="/login">{t('auth.backToLogin')}</Link></div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
